/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'underscore';
import classnames from 'classnames';
import Content from 'app/components/common/Content.jsx';
import CreateFeedHeader from 'app/components/Headers/CreateFeedHeader.jsx';
import ButtonList from 'app/components/common/ButtonList.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import EditorButtons from 'app/components/EditorComponents/EditorButtons.jsx';
import Utilities from 'app/utility/Utilities.js';
import { Outlet } from 'react-router-dom';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class RouteSettings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            cleanRoute: {},
            route: {},
            errors: null,
            currentModal: null
        };

        this.saveRouteSettings = this.saveRouteSettings.bind(this);
        this.cancelAction = this.cancelAction.bind(this);

    }

    static getDerivedStateFromProps(props, state) {
        let nextState = {};

        for (let i = 0; i < props.automatedRoutes.list.length; ++i) {
            if (props.automatedRoutes.list[i].id == props.router.params.routeId && _.isEmpty(state.route)) {
                nextState.cleanRoute = props.automatedRoutes.list[i];
                nextState.route = Utilities.deepClone(props.automatedRoutes.list[i]);
                break;
            }
        }

        let errors = props.getApiErrors(['ROUTE_UPDATE']);
        if (errors.length) {
            nextState.errors = errors[0];
        }

        return (Object.keys(nextState).length) ? nextState : null;

    }

    componentDidMount() {

        let routeId = this.props.router.params.routeId;

        this.props.getRoute(this.props.router.params.routeId);

    }

    componentDidUpdate(prevProps, prevState) {

        let prevRoute = {},
            currentRoute = {},
            i = 0;

        for (i = 0; i < prevProps.automatedRoutes.list.length; ++i) {
            if (prevProps.automatedRoutes.list[i].id == this.props.router.params.routeId) {
                prevRoute = prevProps.automatedRoutes.list[i];
                break;
            }
        }

        for (i = 0; i < this.props.automatedRoutes.list.length; ++i) {
            if (this.props.automatedRoutes.list[i].id == this.props.router.params.routeId) {
                currentRoute = this.props.automatedRoutes.list[i];
                break;
            }
        }

        if (!_.isEmpty(prevRoute) && !_.isEqual(prevRoute, currentRoute)) {
            this.props.router.navigate('/share/automate/detail/' + this.props.router.params.routeId);
        }

    }


    saveRouteSettings(e) {

        e.preventDefault();

        this.props.updateRoute(this.state.route);

    }

    cancelAction(e) {

        if (e) {
            e.preventDefault();
        }

        this.props.router.navigate('/share/automate/detail/' + this.props.router.params.routeId);

    }

    render() {

        let header = null,
            content = null,
            settingsTab = null,
            saveAction = null,
            saveActive = _.isEqual(this.state.route, this.state.cleanRoute) ? false : true,
            buttons = null,
            tripwire = false,
            errorBlock = null,
            errorText = "We couldn't complete that update. Check the highlighted tabs for details.",
            routeId = (this.state.route.id) ? this.state.route.id : 0,
            { children, ...otherProps} = this.props;

        buttons = {
            detail: { link: '/share/automate/settings/' + this.props.router.params.routeId + '/detail', label: 'Detail' },
            filters: { link: '/share/automate/settings/' + this.props.router.params.routeId + '/filters', label: 'Filters' },
            tracking: { link: '/share/automate/settings/' + this.props.router.params.routeId + '/tracking', label: 'Tracking' },
            shorteners: { link: '/share/automate/settings/' + this.props.router.params.routeId + '/shorteners', label: 'Shorteners' }
        };

        for (let key in buttons) {
            if (this.props.router.location.pathname.match(key)) {
                buttons[key].isActive = true;
                tripwire = true;
                break;
            }
        }
        if (!tripwire) {
            buttons.detail.isActive = true;
        }

        if (saveActive) {
            saveAction = this.saveRouteSettings;
        }

        if (this.state.errors !== null) {
            errorBlock = (<div className="detail-status error">{errorText}</div>);
		}

        settingsTab = (
            <div className="editor-title-tabs">
                <div className="editor-title-tab tab-active">
                    <i className="fa fa-cog"></i> Settings
                </div>
            </div>
        );

        header = (
            <CreateFeedHeader
                {...this.props}
                section={this.state.route.name}
                sectionLink={"/share/automate/detail/" + routeId}
                action="Settings"
                tabs={settingsTab} />
        );

        otherProps.route = this.state.route;
        otherProps.routeViewType = this.props.app.flags.routeViewType;
        otherProps.changeHandler = FormUtilityMixin.requestChange.bind(this);
        otherProps.errors = this.state.errors;

        content = (
            <div>
                {errorBlock}
                <ButtonList
                    buttons={[buttons.detail, buttons.filters, buttons.tracking, buttons.shorteners]}
                    wrapperClass="editor-tabs"
                    linkClass="editor-tab-item"
                    activeClass="tab-active"
                    errorClass="tab-error" />
                <Outlet context={otherProps}/>
                <EditorButtons
                    cancelAction={this.cancelAction}
                    saveActive={saveActive}
                    saveAction={saveAction}
                    saveLabel="Save" />
            </div>
        );

        return (
            <Content header={header} main={content} />
        );
    }

};

export default ComponentWithContext(RouteSettings);
